<template>
  <div>
    <h4 class="text-center mb-4">{{ enterpriseInfo.name }}</h4>
    <a-card
      size="small"
      :title="$t('scope.text_584')"
      hoverable
      class="mb-4"
      :loading="loading">
      <router-link slot="extra" :to="{ name: 'Approve', params: { ...enterpriseInfo } }">{{ certifiedAction[customer.certified_status] }}</router-link>
      <vxe-table
        :data="userTableData"
        :show-header="false"
        border="none">
        <vxe-table-column field="label" title="label" width="180" align="right">
          <template v-slot="{ row }">{{ row.label }}：</template>
        </vxe-table-column>
        <vxe-table-column field="value" title="value" width="300">
          <template v-slot="{ row }">
            <template>
              <list-body-cell-wrap :style="row.label === $t('scope.text_625') ? { color: certifiedColor[row.key] } : null" field="value" :row="row" :copy="true">
                <a-tooltip v-if="row.label === $t('scope.text_625') && customer.certified_status === 'denied'">
                  <template slot="title">
                    {{ row.description }}
                  </template>
                  <a-icon class="ml-2" type="question-circle" />
                </a-tooltip>
              </list-body-cell-wrap>
            </template>
          </template>
        </vxe-table-column>
      </vxe-table>
    </a-card>
    <a-card
      size="small"
      :title="$t('scope.text_626')"
      hoverable
      class="mb-4"
      :loading="loading">
      <vxe-table
        :data="companyInfoData"
        :show-header="false"
        border="none">
        <vxe-table-column field="label" title="label" width="180" align="right">
          <template v-slot="{ row }">{{ row.label }}：</template>
        </vxe-table-column>
        <vxe-table-column field="value" title="value" width="400">
          <template v-slot="{ row }">
            <list-body-cell-wrap field="value" :row="row" :copy="true" />
          </template>
        </vxe-table-column>
      </vxe-table>
      <p class="login-address-desc">{{$t('scope.text_628', [loginUrl])}}</p>
    </a-card>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import jsonp from '@/utils/jsonp'

export default {
  name: 'User',
  data () {
    return {
      loading: false,
      enterpriseInfo: {},
      certifiedStatus: {
        certified: this.$t('scope.text_629'),
        certificating: this.$t('scope.text_630'),
        denied: this.$t('scope.text_631'),
        uncertified: this.$t('scope.text_632'),
        unknown: this.$t('scope.text_633'),
      },
      certifiedColor: {
        certified: '#52c41a',
        certificating: '#faad14',
        denied: '#f5222d',
        uncertified: '#f5222d',
        unknown: '#aaa',
      },
      loginUrl: window.location.origin,
      addressDesc: '',
    }
  },
  computed: {
    ...mapGetters(['scope']),
    ...mapState('app', {
      customer: state => state.customer,
    }),
    certifiedAction () {
      return {
        certified: this.scope === 'domain' ? this.$t('scope.text_634') : null,
        certificating: null,
        denied: this.scope === 'domain' ? this.$t('scope.text_635') : null,
        uncertified: this.scope === 'domain' ? this.$t('scope.text_635') : null,
        unknown: this.scope === 'domain' ? this.$t('scope.text_635') : null,
      }
    },
    userTableData () {
      const us = this.enterpriseInfo
      const ret = [
        { label: this.$t('scope.text_318'), value: us.name },
        { label: this.$t('scope.text_636'), value: this.customer.user_name },
        { label: this.$t('scope.text_637'), value: this.customer.mobile },
        { label: this.$t('scope.text_638'), value: this.customer.email },
        { label: this.$t('scope.text_639'), value: this.customer.name },
        { label: this.$t('scope.text_640'), value: this.addressDesc },
        {
          label: this.$t('scope.text_625'),
          value: this.certifiedStatus[this.customer.certified_status],
          key: this.customer.certified_status,
          description: this.customer.description,
        },
      ]
      return ret
    },
    companyInfoData () {
      const ret = [
        { label: this.$t('scope.text_641'), value: this.customer.project_domain },
        { label: this.$t('scope.text_642'), value: this.customer.domain_id },
        { label: this.$t('scope.text_627'), value: `${window.location.origin}/auth/login?domain=${this.customer.project_domain}` },
      ]
      return ret
    },
  },
  async created () {
    this.manager = new this.$Manager('customers')
    if (this.customer.certified_status !== 'uncertified') {
      const { data } = await this.fetchEnterPriseInfo()
      this.enterpriseInfo = data
      await this.cityMap()
    }
  },
  destroyed () {
    this.manager = null
  },
  methods: {
    cityMap () {
      jsonp(`https://apis.map.qq.com/ws/district/v1/search?key=F6QBZ-TCK6X-Q7K47-736QZ-IM7VE-XNFRU&output=jsonp&keyword=${this.enterpriseInfo.reg_address}`, {
        name: 'function1',
      }, async (err, data) => {
        if (err) throw err
        const result = data.result[0][0]
        this.addressDesc = result.address
      })
    },
    fetchEnterPriseInfo () {
      return this.manager.getSpecific({ id: this.customer.id, spec: 'enterprise-info' })
    },
    async doUpdateUserInfo () {
      this.updateDialog.loading = false
      try {
        const values = await this.$refs.updateUserInfo.getValues()
        await this.manager.performAction({
          id: this.userInfo.id,
          action: 'update-contact',
          data: { contacts: values },
        })
        this.fetchContact(false)
        this.updateDialog.visible = false
      } catch (error) {
        throw error
      } finally {
        this.updateDialog.loading = false
      }
    },
  },
}
</script>

<style lang="less" scoped>
.user-info-item-label {
  width: 140px;
}
.login-address-desc {
  margin-left: 150px;
  padding-left: 10px;
  font-size: 13px;
  color: rgba(0,0,0,.45);
}
</style>
